// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"BrowseExtDirectory\"] {\r\n\tbackground: var(--dropdown-bg-selected);\r\n\toverflow: auto;\r\n\tflex-basis: 100%;\r\n    margin: 30px 0px;\r\n}", ""]);
// Exports
module.exports = exports;
